import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 17,
	viewBox: "0 0 10 17",
	fill: "#B5B5B5",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.97266 8.44C9.97266 8.04 9.81266 7.66 9.53266 7.38L2.55266 0.439999C2.27266 0.139999 1.89266 -3.52204e-07 1.51266 -3.68768e-07C1.11266 -3.86204e-07 0.732657 0.139999 0.432657 0.439999C-0.147343 1.04 -0.147345 1.98 0.452656 2.56L6.35266 8.44L0.452655 14.32C-0.147345 14.9 -0.147343 15.86 0.432657 16.44C1.03266 17.04 1.97266 17.04 2.55266 16.44L9.53266 9.5C9.81266 9.22 9.97266 8.84 9.97266 8.44Z" })
});
export default SvgArrow2;
